// extracted by mini-css-extract-plugin
export default {"managerReportToolbar":"manager-reports-page_managerReportToolbar__UXyGG","autoCloseNote":"manager-reports-page_autoCloseNote__IT8+U"};